import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
interface LocationStepProps {
  onNext: (state: string) => void;
  defaultValue?: string;
}
const US_STATES = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
export function LocationStep({
  onNext,
  defaultValue
}: LocationStepProps) {
  const [selectedState, setSelectedState] = useState(defaultValue || '');
  const [isDetecting, setIsDetecting] = useState(!defaultValue);
  useEffect(() => {
    if (isDetecting) {
      const timer = setTimeout(() => {
        setIsDetecting(false);
        if (!selectedState) {
          setSelectedState('Texas');
        }
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [isDetecting, selectedState]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (selectedState) {
      onNext(selectedState);
    }
  };
  return <div className="w-full max-w-md mx-auto px-4 py-1 sm:py-4" data-id="element-153">
      <div className="text-center mb-3 sm:mb-5" data-id="element-154">
        <div className="inline-flex items-center justify-center w-9 h-9 rounded-full bg-blue-50 text-primary mb-1.5" data-id="element-155">
          <MapPin className="w-4 h-4" data-id="element-156" />
        </div>
        <h2 className="text-xl sm:text-3xl font-bold text-dark mb-1" data-id="element-157">
          ¿En qué estado resides?
        </h2>
        <p className="text-gray-600 text-xs sm:text-sm" data-id="element-158">
          Para mostrarte las mejores tarifas disponibles
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-3" data-id="element-159">
        <div className="relative" data-id="element-160">
          {isDetecting ? <div className="w-full p-3.5 bg-white rounded-lg border border-gray-200 text-center text-gray-500 flex items-center justify-center gap-2 text-sm" data-id="element-161">
              <div className="w-4 h-4 border-2 border-primary border-t-transparent rounded-full animate-spin" data-id="element-162"></div>
              Detectando ubicación...
            </div> : <select value={selectedState} onChange={e => setSelectedState(e.target.value)} className="w-full p-3.5 bg-white rounded-lg border-2 border-gray-200 focus:border-primary focus:ring-0 outline-none text-base appearance-none cursor-pointer transition-colors" required data-id="element-163">
              <option value="" disabled data-id="element-164">
                Selecciona tu estado
              </option>
              {US_STATES.map(state => <option key={state} value={state} data-id="element-165">
                  {state}
                </option>)}
            </select>}
          {!isDetecting && <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400" data-id="element-166">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-167">
                <path d="m6 9 6 6 6-6" data-id="element-168" />
              </svg>
            </div>}
        </div>

        <motion.button whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} type="submit" disabled={!selectedState || isDetecting} className="w-full bg-primary hover:bg-primary-hover text-white font-bold text-base py-3.5 px-6 rounded-lg shadow-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2" data-id="element-169">
          ✅ Confirmar ubicación
        </motion.button>
      </form>
    </div>;
}